// Drop-in replacement for @clerk/clerk-react's useUser() hook.
// Returns { user, isLoaded, isSignedIn, signOut } in the same shape Clerk uses.

import { useAuth } from "@/contexts/AuthContext";

// Map our user shape → Clerk's user shape so existing components work unchanged
function mapUser(user) {
    if (!user) return null;
    return {
        id: user._id,
        primaryEmailAddress: { emailAddress: user.email },
        emailAddresses: [{ emailAddress: user.email }],
        fullName: user.full_name,
        firstName: (user.full_name || "").split(" ")[0] || null,
        lastName: (user.full_name || "").split(" ").slice(1).join(" ") || null,
        imageUrl: user.profile_image || null,
        username: user.user_id,
        publicMetadata: { user_id: user.user_id, is_platform_admin: user.is_platform_admin },
        // Keep raw fields too
        _raw: user,
    };
}

export function useUser() {
    const { user, isLoading, logout } = useAuth();
    return {
        user: mapUser(user),
        isLoaded: !isLoading,
        isSignedIn: !!user,
        // Clerk-compatible alias — Settings.jsx (and other pages) call
        // `signOut()` on the hook result, not `logout()`.
        signOut: logout,
    };
}
